export const QUERY_DELAY = 1100;
export const NULL_QUERY_DELAY = 0;
